import { render, staticRenderFns } from "./workOrderInfo.vue?vue&type=template&id=6a37848e&scoped=true"
import script from "./workOrderInfo.vue?vue&type=script&lang=js"
export * from "./workOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./workOrderInfo.vue?vue&type=style&index=0&id=6a37848e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37848e",
  null
  
)

export default component.exports